import { getWidget, observeElement } from '@uvocore-front/utils';
import '../../components/Header/main';
import '../../components/Footer';
import mobilePricingInit from './sections/price-table-section';
import setSelectActiveClass from '../../components/UI/select';
import { DefaultCalculator } from '../../components/Calculator';

// Run
document.addEventListener('DOMContentLoaded', () => {
  const priceTable = document.querySelector('.PriceTable');

  if (priceTable) {
    observeElement({
      element: '.PriceTable',
      marginValue: 200,
      callback: () => {
        mobilePricingInit();
        setSelectActiveClass(document.querySelector('.PriceTable'));
      },
    });
  }
});

observeElement({
  element: '[data-calc-mini]',
  marginValue: 300,
  callback: () => {
    getWidget({
      widgetLink: '/assets/js/calc.js',
      loader: true,
      fn: () => {
        DefaultCalculator();
      },
    });
  },
});
